<app-modal [dismissable]="true" [title]="'Settings' | translate">
    <div ngbAutoFocus style="height: 640px !important; overflow-y: auto" class="modal-content pt-0">
        <ul ngbNav #nav="ngbNav" [(activeId)]="activeNav" (activeIdChange)="onPartnerTabChange($event)"
            class="nav-tabs">
            <li *ngIf="profileService.isOwner" [ngbNavItem]="0">
                <button ngbNavLink>{{'Clinic Info' | translate}}</button>
                <ng-template ngbNavContent>
                    <div class="tab-content-wrapper py-3">
                        <div class="section-header mb-4">
                            <div class="d-flex align-items-center">
                                <div class="icon-wrapper me-3">
                                    <i class="ti ti-building fs-2 text-primary"></i>
                                </div>
                                <div>
                                    <h4 class="mb-1 fw-semibold">{{ 'Clinic Information' | translate }}</h4>
                                    <p class="text-muted mb-0 small">
                                        {{ 'Manage your business details, contact and location information' | translate }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="alert alert-warning d-flex align-items-center mb-4" role="alert"
                            style="background-color: #fff8e1; border-color: #ffecb5;">
                            <i class="ti ti-alert-triangle me-2 text-warning"></i>
                            <div>
                                <strong>Important:</strong> Changes to the clinic name, the representative, the
                                contact details (email, phone number) or the location and address require a new
                                approval by our team: your account will return to <em>pending verification</em> and
                                you will not be able to access the website's features until it is approved again.
                                Changes to WhatsApp, ZIP code and house number do not require re-approval.
                            </div>
                        </div>

                        <form (ngSubmit)="submit()" [formGroup]="updateForm">
                            <formly-form [form]="updateForm" [fields]="updateFields" [model]="updateModel">
                            </formly-form>
                            <div *ngIf="activeNav === 0 && pendingEmailNotice" class="text-warning small mt-1">
                                Pending email confirmation: {{ pendingEmailNotice }}
                            </div>
                        </form>
                    </div>
                </ng-template>
            </li>

            <li [ngbNavItem]="1">
                <button ngbNavLink>{{'Password' | translate}}</button>
                <ng-template ngbNavContent>
                    <div class="tab-content-wrapper py-3">
                        <div class="section-header mb-4">
                            <div class="d-flex align-items-center">
                                <div class="icon-wrapper me-3">
                                    <i class="ti ti-lock fs-2 text-primary"></i>
                                </div>
                                <div>
                                    <h4 class="mb-1 fw-semibold">{{ 'Change Password' | translate }}</h4>
                                    <p class="text-muted mb-0 small">
                                        {{ 'Update your password to keep your account secure' | translate }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="alert alert-info d-flex align-items-start mb-4" role="alert">
                            <i class="ti ti-info-circle me-2 mt-1"></i>
                            <div>
                                <small><strong>{{ 'Security tip:' | translate }}</strong>
                                    {{ 'Use a strong password with at least 8 characters, including letters and numbers'
                                    | translate }}</small>
                            </div>
                        </div>

                        <form (ngSubmit)="submitPassword()" [formGroup]="passwordForm">
                            <formly-form [form]="passwordForm" [fields]="passwordFields" [model]="passwordModel">
                            </formly-form>
                        </form>
                    </div>
                </ng-template>
            </li>

            <li *ngIf="profileService.isOwner" [ngbNavItem]="2">
                <button ngbNavLink>{{'Preferences' | translate}}</button>
                <ng-template ngbNavContent>
                    <div class="tab-content-wrapper py-3">
                        <div class="section-header mb-4">
                            <div class="d-flex align-items-center">
                                <div class="icon-wrapper me-3">
                                    <i class="ti ti-adjustments fs-2 text-primary"></i>
                                </div>
                                <div>
                                    <h4 class="mb-1 fw-semibold">{{ 'Preferences' | translate }}</h4>
                                    <p class="text-muted mb-0 small">
                                        {{ 'Manage your clinic availability and preferences' | translate }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <form (ngSubmit)="submitPreferences()" [formGroup]="preferenceForm">
                            <div class="preference-section mb-4">
                                <div class="d-flex align-items-start">
                                    <div class="flex-grow-1">
                                        <div class="d-flex align-items-center mb-2">
                                            <i class="ti ti-beach me-2 text-warning fs-4"></i>
                                            <h5 class="mb-0 fw-semibold">{{ 'Holiday Mode' | translate }}</h5>
                                        </div>
                                        <p class="text-muted small mb-3">
                                            While holiday mode is active your clinic stays visible in search results
                                            and you keep receiving paid quote and contact requests, but you will not be
                                            selected for free quote requests. Use this when you are on vacation or
                                            temporarily unavailable.
                                        </p>
                                        <div class="alert alert-warning d-flex align-items-start mb-0" role="alert"
                                            *ngIf="preferenceModel.holidayMode">
                                            <i class="ti ti-alert-triangle me-2 mt-1"></i>
                                            <small>
                                                <strong>{{ 'Active:' | translate }}</strong> Your clinic is
                                                currently in holiday mode: it is still visible in search results and
                                                receives paid quote and contact requests, but it will not be selected
                                                for free quote requests.
                                            </small>
                                        </div>
                                    </div>
                                    <div class="ms-3">
                                        <formly-form [form]="preferenceForm" [fields]="preferenceFields"
                                            [model]="preferenceModel">
                                        </formly-form>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </ng-template>
            </li>

            <!-- Tab id 3 (Notifications) was removed: notifications always go to the login email of each
                 team member. Ids are kept stable (Delete Account stays 4). -->

            <li *ngIf="profileService.healthDataEligible && profileService.isPartnerApproved" [ngbNavItem]="5">
                <button ngbNavLink><i class="ti ti-shield-lock me-1"></i>Health data</button>
                <ng-template ngbNavContent>
                    <div class="tab-content-wrapper py-3">
                        <h4 class="mb-1 fw-semibold">Health data declaration</h4>
                        <p class="text-muted small mb-4">
                            Patients' health data (treatment needs, medical notes, x-rays, images, quote PDFs) is shown
                            only to users who declared they are legally entitled to access it.
                        </p>
                        <div class="alert d-flex align-items-center gap-2"
                            [ngClass]="profileService.profile?.healthDataDeclaration === 'GRANTED' ? 'alert-success' : 'alert-warning'">
                            <i class="ti" [ngClass]="profileService.profile?.healthDataDeclaration === 'GRANTED' ? 'ti-circle-check' : 'ti-lock'"></i>
                            <span *ngIf="profileService.profile?.healthDataDeclaration === 'GRANTED'">
                                You declared you are legally entitled to access patients' health data.
                            </span>
                            <span *ngIf="profileService.profile?.healthDataDeclaration === 'DENIED'">
                                You declared you are not entitled: health data is hidden.
                            </span>
                            <span *ngIf="!profileService.profile?.healthDataDeclaration">
                                You have not declared yet: health data is hidden.
                            </span>
                        </div>
                        <div class="d-flex gap-2">
                            <app-button *ngIf="profileService.profile?.healthDataDeclaration !== 'GRANTED'" buttonType="primary"
                                label="I declare I am legally entitled" [isDisabled]="isSubmitting"
                                (onClick)="changeHealthDeclaration('GRANTED')"></app-button>
                            <app-button *ngIf="profileService.profile?.healthDataDeclaration !== 'DENIED'" buttonType="light"
                                label="I am not entitled" [isDisabled]="isSubmitting"
                                (onClick)="changeHealthDeclaration('DENIED')"></app-button>
                        </div>
                    </div>
                </ng-template>
            </li>

            <!-- Danger Zone tab — owner only -->
            <li *ngIf="profileService.isOwner" [ngbNavItem]="4">
                <button ngbNavLink class="text-danger" (click)="loadDeletionStatus()">
                    <i class="ti ti-trash me-1"></i>Delete Account
                </button>
                <ng-template ngbNavContent>
                    <div class="tab-content-wrapper py-3">
                        <div class="section-header mb-4">
                            <div class="d-flex align-items-center">
                                <div class="icon-wrapper me-3"
                                    style="background: linear-gradient(135deg, #fff1f0 0%, #ffccc7 100%);">
                                    <i class="ti ti-trash-x fs-2 text-danger"></i>
                                </div>
                                <div>
                                    <h4 class="mb-1 fw-semibold text-danger">Danger Zone</h4>
                                    <p class="text-muted mb-0 small">
                                        Request the permanent deletion of your clinic account
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Main danger warning banner -->
                        <div class="danger-zone-banner mb-4 p-4">
                            <div class="d-flex align-items-start gap-3">
                                <i class="ti ti-alert-octagon fs-1 text-danger flex-shrink-0"></i>
                                <div>
                                    <h5 class="fw-bold text-danger mb-2">
                                        Permanently delete your account
                                    </h5>
                                    <p class="mb-2 text-dark">
                                        Your clinic is <strong>disabled immediately</strong>: it is no longer visible to
                                        patients, it will not receive new quote or contact requests, your active
                                        subscriptions are cancelled and team members can no longer sign in.
                                    </p>
                                    <p class="mb-2 text-dark">
                                        You then have <strong>{{ deletionGraceDays }} days</strong> to change your mind:
                                        sign in with the owner account and click <em>Cancel deletion</em>. After that,
                                        all your data is permanently erased, including:
                                    </p>
                                    <ul class="mb-3 text-muted small">
                                        <li>Clinic profile and all listings</li>
                                        <li>All received quote and contact requests</li>
                                        <li>Reviews and ratings</li>
                                        <li>Team members and their accounts</li>
                                        <li>Subscriptions and wallet</li>
                                    </ul>
                                    <p class="mb-3 text-muted small">
                                        Invoices are kept as required by tax regulations. Subscriptions are not
                                        restored if you cancel the deletion.
                                    </p>

                                    <div *ngIf="deletionStatus && !deletionStatus.canRequest && deletionStatus.blockingReason"
                                        class="alert alert-warning d-flex align-items-center gap-2 mb-3 py-2" role="alert">
                                        <i class="ti ti-receipt fs-5 flex-shrink-0"></i>
                                        <small>{{ deletionStatus.blockingReason }}</small>
                                    </div>

                                    <div class="alert alert-danger d-flex align-items-center gap-2 mb-3 py-2"
                                        role="alert">
                                        <i class="ti ti-exclamation-circle fs-5 flex-shrink-0"></i>
                                        <small>
                                            <strong>Warning:</strong>
                                            once the {{ deletionGraceDays }} days have passed the deletion cannot be undone.
                                            Download any invoice or data you need before then.
                                        </small>
                                    </div>
                                    <button type="button" class="btn btn-danger btn-sm d-inline-flex align-items-center gap-2 w-auto"
                                        [disabled]="isLoadingDeletionStatus || isRequestingDeletion || (deletionStatus != null && !deletionStatus.canRequest)"
                                        (click)="openDeleteAccountConfirm()">
                                        <i class="ti ti-trash"></i>
                                        Delete my account
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </li>
        </ul>

        <div class="nav-content" [ngbNavOutlet]="nav"></div>
    </div>
    <div class="modal-actions w-100 d-flex align-items-center justify-content-end gap-2 h-100">
        <app-button type="button" buttonType="light" (onClick)="cancel()" label="{{ 'Cancel' | translate }}">
        </app-button>
        <app-button *ngIf="activeNav === 0" type="button" (onClick)="submit()"
            [isDisabled]="!updateForm.valid || isSubmitting" label="{{ 'Save Changes' | translate }}">
        </app-button>
        <app-button *ngIf="activeNav === 1" type="button" (onClick)="submitPassword()"
            [isDisabled]="!passwordForm.valid || isSubmitting" label="{{ 'Update Password' | translate }}">
        </app-button>
        <app-button *ngIf="activeNav === 2" type="button" (onClick)="submitPreferences()"
            [isDisabled]="isSubmitting || !hasHolidayModeChanged()" label="{{ 'Save Changes' | translate }}">
        </app-button>
        <!-- tab 4 (Danger Zone) has no footer button — action is inline -->
    </div>
</app-modal>
